import { render, staticRenderFns } from "./SenaEditions.vue?vue&type=template&id=114a57a9&"
import script from "./SenaEditions.vue?vue&type=script&lang=js&"
export * from "./SenaEditions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports